module.exports = __webpack_public_path__ + "static/media/detail.12bdf019.svg";